import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bi-tmpl-detail__right__cmpt" }
const _hoisted_2 = {
  key: 0,
  class: "bi-tmpl-detail__right__cmpt__title"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "bi-tmpl-detail__right__cmpt__title",
  style: {"margin-top":"0"}
}, " 请选择图表样式 ", -1)
const _hoisted_4 = {
  key: 0,
  style: {"margin-top":"0"},
  class: "bi-tmpl-detail__right__cmpt__tips"
}

import { BaseRadio } from 'xrk-components';
import { BaseCard } from 'xrk-components';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import { Carousel } from '@/components/base/carousel';
import PcModuleDistribute from '@/views/bi-tmpl/src/components/bi-pc-module/pc-module-distribute/index';


export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-21-4',
  setup(__props) {

const TYPE_MAPPING = [
  {
    com: 'pc-module-distribute-1',
    index: 1,
    value: '18'
  },
  {
    com: 'pc-module-distribute-2',
    index: 2,
    value: '2'
  },
  {
    com: 'pc-module-distribute-3',
    index: 3,
    value: '9'
  },
  {
    com: 'pc-module-distribute-4',
    index: 4,
    value: '10'
  },
  {
    com: 'pc-module-distribute-5',
    index: 5,
    value: '14'
  },
  {
    com: 'pc-module-distribute-6',
    index: 6,
    value: '16'
  },
  {
    com: 'pc-module-distribute-7',
    index: 7,
    value: '15'
  },
  {
    com: 'pc-module-distribute-8',
    index: 8,
    value: '20'
  },
  {
    com: 'pc-module-distribute-9',
    index: 9,
    value: '23'
  },
  {
    com: 'pc-module-distribute-10',
    index: 10,
    value: '17'
  },
  {
    com: 'pc-module-distribute-11',
    index: 11,
    value: '21'
  },
  {
    com: 'pc-module-distribute-12',
    index: 12,
    value: '22'
  }
];

const cmpName = name => {
  return PcModuleDistribute.filter(comp => comp.__name === name)[0];
};

const { curItem, onChange, group } = useDetailCmpt();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(curItem).tips)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(curItem).title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _hoisted_3,
      (_unref(curItem).tips)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(curItem).tips), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(Carousel), {
      ref: "carouselRef",
      itemHeight: 1000,
      itemWidth: 421 + 56
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(group)(TYPE_MAPPING, 3), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            style: {"width":"100%"},
            key: index
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (child) => {
              return (_openBlock(), _createElementBlock("div", {
                key: child.value
              }, [
                _createVNode(_unref(BaseCard), {
                  style: {"width":"421px","height":"356px","text-align":"center","margin-bottom":"18px"},
                  onClick: ($event: any) => (_unref(onChange)(child.value))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(cmpName(child.com)), { style: {"height":"calc(356px - 60px)"} })),
                    _createVNode(_unref(BaseRadio), {
                      value: child.value,
                      "model-value": _unref(curItem).value
                    }, null, 8, ["value", "model-value"])
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]))
            }), 128))
          ]))
        }), 128))
      ]),
      _: 1
    }, 512)
  ]))
}
}

})